import React from "react";
import MerchantLayout from "../../components/MerchantLayouts";
import BusinessModelCreate from "../../components/Business/BusinessModelCrate";

const BusinessModelPage = () => {
  return (
    <MerchantLayout>
      <BusinessModelCreate />
    </MerchantLayout>
  ); 
};

export default BusinessModelPage;
